import * as React from 'react'
import { Link } from 'react-router'

type Path = {
  title: string
  to: any
  current?: boolean
}

type Props = {
  paths: Path[]
}

export const Breadcrumbs = ({ paths }: Props): JSX.Element => (
  <ul className="bp3-breadcrumbs">
    {paths.map(p => (
      <li key={p.title}>
        {p.current ? (
          <span className="bp3-breadcrumb-current">{p.title}</span>
        ) : (
          <Link to={p.to} className="bp3-breadcrumb">
            {p.title}
          </Link>
        )}
      </li>
    ))}
  </ul>
)
